"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const YouTubeIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== 'auto') {
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
        size.width = width;
    }
    if (height && height !== 'auto') {
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
        size.height = height;
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "-0.25 -0.25 18 13" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M19.185,8.668A3.923,3.923,0,0,0,18.5,6.931a2.747,2.747,0,0,0-1.737-.744C14.346,6,10.685,6,10.685,6s-3.66,0-6.08.186a2.631,2.631,0,0,0-1.737.744,4.2,4.2,0,0,0-.682,1.737A25.288,25.288,0,0,0,2,11.521v1.365a25.288,25.288,0,0,0,.186,2.854,3.923,3.923,0,0,0,.682,1.737,3.026,3.026,0,0,0,1.923.744c1.365.124,5.894.186,5.894.186s3.66,0,6.08-.186a2.747,2.747,0,0,0,1.737-.744,4.2,4.2,0,0,0,.682-1.737,25.288,25.288,0,0,0,.186-2.854V11.521a25.288,25.288,0,0,0-.186-2.854ZM8.886,14.5V9.536L13.6,12.018Z", transform: "translate(-2 -6)" }))));
};
exports.default = YouTubeIconM;
//# sourceMappingURL=index.js.map